/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CalculateBestRateInput = {
    bookingId?: string | null | undefined;
    customerId: string;
    enddate: string;
    plannedDistance: string;
    pricelist?: string | null | undefined;
    startdate: string;
    startstation: string;
    tmpBookingId?: string | null | undefined;
    vehicleGroup: string;
    voucherCode?: string | null | undefined;
};
export type CalculateBestRateMutationVariables = {
    input: CalculateBestRateInput;
};
export type CalculateBestRateMutationResponse = {
    readonly calculateBestRateMutation: ReadonlyArray<{
        readonly invoicePositionId: string;
        readonly bookingId: string | null;
        readonly position: number;
        readonly rate: string | null;
        readonly description: string | null;
        readonly amount: number | null;
        readonly unit: string | null;
        readonly netSinglePrice: number | null;
        readonly grossPrice: number | null;
        readonly grossTotalPrice: number | null;
        readonly includedDistance: number | null;
        readonly discount: number | null;
    } | null>;
};
export type CalculateBestRateMutation = {
    readonly response: CalculateBestRateMutationResponse;
    readonly variables: CalculateBestRateMutationVariables;
};



/*
mutation CalculateBestRateMutation(
  $input: CalculateBestRateInput!
) {
  calculateBestRateMutation(input: $input) {
    invoicePositionId
    bookingId
    position
    rate
    description
    amount
    unit
    netSinglePrice
    grossPrice
    grossTotalPrice
    includedDistance
    discount
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "InvoicePosition",
    "kind": "LinkedField",
    "name": "calculateBestRateMutation",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "invoicePositionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookingId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "position",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "netSinglePrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "grossPrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "grossTotalPrice",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includedDistance",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "discount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalculateBestRateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalculateBestRateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d4c46eefb96e6fbd6959dd9e5d364e2a",
    "id": null,
    "metadata": {},
    "name": "CalculateBestRateMutation",
    "operationKind": "mutation",
    "text": "mutation CalculateBestRateMutation(\n  $input: CalculateBestRateInput!\n) {\n  calculateBestRateMutation(input: $input) {\n    invoicePositionId\n    bookingId\n    position\n    rate\n    description\n    amount\n    unit\n    netSinglePrice\n    grossPrice\n    grossTotalPrice\n    includedDistance\n    discount\n  }\n}\n"
  }
};
})();
(node as any).hash = '2110acdcfa908f1f3821d9e779153084';
export default node;
